import { Switch, type SwitchState } from "@/components/Switch";
import { Text } from "@/components/podkit/typography/Text";
import { cn } from "@/components/podkit/lib/cn";
import { useId, type ReactNode } from "react";

export type ToggleFieldProps = {
    id?: string;
    label: ReactNode;
    description?: ReactNode;
    state: SwitchState;
    onCheckedChange: (checked: boolean) => void | Promise<void>;
    disabled?: boolean;
    className?: string;
    "data-testid"?: string;
};
export const ToggleField = ({
    id,
    label,
    description,
    state,
    onCheckedChange,
    disabled = false,
    className,
    "data-testid": testId,
}: ToggleFieldProps) => {
    const generatedId = useId();
    const toggleId = id ?? testId ?? generatedId;

    const handleToggle = async (newChecked: boolean) => {
        const result = onCheckedChange(newChecked);
        if (result instanceof Promise) {
            await result;
        }
    };

    return (
        <div className={cn("flex gap-4", className)}>
            <Switch
                state={state}
                onToggle={handleToggle}
                disabled={disabled}
                id={toggleId}
                data-testid={testId}
                aria-label={typeof label === "string" ? label : undefined}
            />
            <div className="flex flex-col">
                <label className="cursor-pointer font-bold" htmlFor={toggleId}>
                    {label}
                </label>
                {description && <Text muted>{description}</Text>}
            </div>
        </div>
    );
};
